import { useAbTestComponent, loadUsualComponent } from "@hook";
import { inject, observer } from "mobx-react";
import AB_2613 from "./AB_2613";
import AB_2659 from "./AB_2659";
import AB_2771 from "./AB_2771";
import AB_3274 from "./AB_3274";
import Default from "./Default";

const abTests = {
    dev_2613__v2: loadUsualComponent(AB_2613),
    dev_2771__v2: loadUsualComponent(AB_2771),
    dev_3274__v2: loadUsualComponent(AB_3274),
    dev_3632__v2: loadUsualComponent(AB_3274),
    dev_2659__v2: loadUsualComponent(AB_2659),
};

const InputTextUi = inject("mainStore")(
    observer(({ mainStore, ...props }) => {
        const init = mainStore.getMainStore("init");
        const Specified = useAbTestComponent({ init, abTests, defaultComponent: Default });

        return <Specified {...props} />;
    }),
);

export default InputTextUi;
